import React, { useEffect, useState } from "react";

export default function PersonalDetails({ report }) {
  // Utility to ensure data is always an array for safe mapping
  const normalizeToArray = (data) => {
    if (!data) return [];
    return Array.isArray(data) ? data : [data];
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const [year, month, day] = dateString.split("+")[0].split("-");
    return `${day}/${month}/${year}`;
  };

  const consumerInfo = {
    name: report?.personal?.name || "N/A",
    dob: formatDate(report?.personal?.dob) || "N/A",
    gender: report?.personal?.gender || "N/A",
    score: report?.score?.value || "N/A",
  };

  const identifications = [
    {
      type: "INCOME TAX ID NUMBER (PAN)",
      number: report?.personal?.pan || "N/A",
      issue: "",
      expiry: "",
    },
    {
      type: "UNIVERSAL ID NUMBER (UID)",
      number: report?.personal?.rationCard || "N/A",
      issue: "",
      expiry: "",
    },
    {
      type: "CkycId",
      number: report?.personal?.ckyc || "N/A",
      issue: "",
      expiry: "",
    },
  ];

  const [phones, setPhones] = useState([]);

  useEffect(() => {
    if (!report?.personal?.allPhones) return;

    // Normalize phones to array whether it's an object or already an array
    const phoneData = normalizeToArray(report.personal.allPhones);

    const phoneList = phoneData.map((element) => ({
      type: element?.PhoneType?.symbol === "01" ? "Mobile Phone" : "Home/Office Phone",
      number: element?.PhoneNumber?.Number || "N/A",
      ext: "",
    }));

    setPhones(phoneList);
  }, [report?.personal?.allPhones]);

  // Normalize emails and addresses to arrays
  const emails = normalizeToArray(report?.personal?.allEmails);
  const addresses = normalizeToArray(report?.personal?.allAddresses);
  const employments = report?.employment;

  return (
    <div className="w-full max-w-6xl p-4 bg-white text-gray-800 font-sans text-[10px] print:p-0">
      
      {/* 1. CONSUMER INFORMATION SECTION */}
      {/* <div className="mb-6">
        <h3 className="text-[12px] font-bold text-gray-700 mb-1 uppercase tracking-tight">
          CONSUMER INFORMATION:
        </h3>
        <div className="bg-[#f2f4f6] p-2.5 flex flex-wrap justify-between items-center text-[10px]">
          <div className="flex gap-1.5">
            <span className="text-[#00a1de] font-bold uppercase">CONSUMER NAME :</span>
            <span className="text-black font-bold uppercase">{consumerInfo.name}</span>
          </div>
          <div className="flex gap-1.5">
            <span className="text-[#00a1de] font-bold uppercase">D.O.B :</span>
            <span className="text-black font-bold uppercase">{consumerInfo.dob}</span>
          </div>
          <div className="flex gap-1.5">
            <span className="text-[#00a1de] font-bold uppercase">GENDER :</span>
            <span className="text-black font-bold uppercase">{consumerInfo.gender}</span>
          </div>
          <div className="flex gap-1.5">
            <span className="text-[#00a1de] font-bold uppercase">
              CREDITVISION<sup className="font-medium text-[8px]">®</sup> SCORE :
            </span>
            <span className="text-black font-bold">{consumerInfo.score}</span>
          </div>
        </div>
      </div> */}

      {/* 2. IDENTIFICATION(S) SECTION */}
      <div className="mb-6">
        <h3 className="text-[12px] font-bold text-gray-700 mb-1 uppercase tracking-tight">
          IDENTIFICATION(S):
        </h3>
        <div className="bg-[#f2f4f6] p-2.5">
          <table className="w-full text-left border-collapse border-spacing-0">
            <thead>
              <tr>
                <th className="py-1 text-[10px] font-bold text-[#00a1de] uppercase w-1/3">
                  IDENTIFICATION TYPE
                </th>
                <th className="py-1 text-[10px] font-bold text-[#00a1de] uppercase w-1/3">
                  IDENTIFICATION NUMBER
                </th>
                <th className="py-1 text-[10px] font-bold text-[#00a1de] uppercase w-1/6">
                  ISSUE DATE
                </th>
                <th className="py-1 text-[10px] font-bold text-[#00a1de] uppercase w-1/6">
                  EXPIRATION DATE
                </th>
              </tr>
            </thead>
            <tbody>
              {identifications.map((id, index) => (
                <tr key={index}>
                  <td className="m-0 p-0 text-[10px] font-bold text-black uppercase">{id.type}</td>
                  <td className="m-0 p-0 text-[10px] font-bold text-black uppercase">{id.number}</td>
                  <td className="m-0 p-0 text-[10px] font-bold text-black">{id.issue}</td>
                  <td className="m-0 p-0 text-[10px] font-bold text-black">{id.expiry}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* 3. TELEPHONE(S) SECTION */}
      <div className="mb-6">
        <h3 className="text-[12px] font-bold text-gray-700 mb-1 uppercase tracking-tight">
          TELEPHONE(S):
        </h3>
        <div className="bg-[#f2f4f6] p-2.5">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr>
                <th className="py-1 text-[10px] font-bold text-[#00a1de] uppercase w-1/3">
                  TELEPHONE TYPE
                </th>
                <th className="py-1 text-[10px] font-bold text-[#00a1de] uppercase w-1/3">
                  TELEPHONE NUMBER
                </th>
                <th className="py-1 text-[10px] font-bold text-[#00a1de] uppercase w-1/3">
                  TELEPHONE EXTENSION
                </th>
              </tr>
            </thead>
            <tbody>
              {phones.length > 0 ? (
                phones.map((tel, index) => (
                  <tr key={index}>
                    <td className="m-0 p-0 text-[10px] font-bold text-black uppercase">{tel.type}</td>
                    <td className="m-0 p-0 text-[10px] font-bold text-black uppercase">{tel.number}</td>
                    <td className="m-0 p-0 text-[10px] font-bold text-black uppercase">{tel.ext}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className=" text-[10px] font-bold text-black uppercase">
                    N/A
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* 4. EMAIL CONTACT(S) SECTION */}
      <div className="mb-6">
        <h3 className="text-[12px] font-bold text-gray-700 mb-1 uppercase tracking-tight">
          EMAIL CONTACT(S):
        </h3>
        <div className="bg-[#f2f4f6] p-2.5">
          <div className="text-[10px] font-bold text-[#00a1de] uppercase mb-1">
            EMAIL ADDRESS
          </div>
          {emails.length > 0 ? (
            emails.map((emailObj, index) => (
              <div key={index} className="m-0 p-0 text-[10px] font-bold text-black uppercase">
                {emailObj?.Email || "N/A"}
              </div>
            ))
          ) : (
            <div className=" text-[10px] font-bold text-black uppercase">N/A</div>
          )}
        </div>
      </div>

      {/* 5. ADDRESS(ES) SECTION */}
      <div className="mb-6">
        <h3 className="text-[12px] font-bold text-gray-700 mb-1 uppercase tracking-tight">
          ADDRESS(ES):
        </h3>
        <div className="flex flex-col gap-1">
          {addresses.length > 0 ? (
            addresses.map((addr, index) => (
              <div
                key={index}
                className={`p-2.5 ${index % 2 === 0 ? "bg-[#f2f4f6]" : "bg-white"}`}
              >
                <div className=" leading-tight">
                  <span className="text-[#00a1de] font-bold uppercase">ADDRESS : </span>
                  <span className="text-black font-bold uppercase">
                    {addr?.CreditAddress?.StreetAddress || "N/A"}
                  </span>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-2 text-[10px]">
                  <div>
                    <span className="text-[#00a1de] font-bold uppercase">CATEGORY: </span>
                    <span className="text-black font-bold uppercase">
                      {addr?.category || "N/A"}
                    </span>
                  </div>
                  <div>
                    <span className="text-[#00a1de] font-bold uppercase">RESIDENCE CODE: </span>
                    <span className="text-black font-bold uppercase">
                      {addr?.CreditAddress?.PostalCode || "N/A"}
                    </span>
                  </div>
                  <div>
                    <span className="text-[#00a1de] font-bold uppercase">DATE REPORTED: </span>
                    <span className="text-black font-bold uppercase">
                      {addr?.dateReported || "N/A"}
                    </span>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="bg-[#f2f4f6] p-2.5 text-[10px] font-bold text-black uppercase">
              N/A
            </div>
          )}
        </div>
      </div>

      {/* 6. EMPLOYMENT INFORMATION SECTION */}
      {employments && (
        <div className="mb-6">
          <h3 className="text-[12px] font-bold text-gray-700 mb-1 uppercase tracking-tight">
            EMPLOYMENT INFORMATION:
          </h3>
          <div className="bg-[#f2f4f6] p-2.5">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr>
                  <th className="py-1 text-[10px] font-bold text-[#00a1de] uppercase w-1/5">
                    ACCOUNT TYPE <span className="normal-case font-normal">(Date Reported)</span>
                  </th>
                  <th className="py-1 text-[10px] font-bold text-[#00a1de] uppercase w-1/5">
                    OCCUPATION TYPE
                  </th>
                  <th className="py-1 text-[10px] font-bold text-[#00a1de] uppercase w-1/5">
                    INCOME
                  </th>
                  <th className="py-1 text-[10px] font-bold text-[#00a1de] uppercase w-1/5">
                    NET/GROSS INDICATOR
                  </th>
                  <th className="py-1 text-[10px] font-bold text-[#00a1de] uppercase w-1/5">
                    MONTHLY/ANNUAL INDICATOR
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className=" text-[10px] font-bold text-black uppercase">
                    {employments?.accountType || "N/A"}{" "}
                    {employments?.dateReported && (
                      <span className="text-gray-600 font-normal">
                        ({formatDate(employments?.dateReported)})
                      </span>
                    )}
                  </td>
                  <td className=" text-[10px] font-bold text-black uppercase">
                    {employments?.OccupationCode?.description || "N/A"}
                  </td>
                  <td className=" text-[10px] font-bold text-black uppercase">
                    {employments?.income || "N/A"}
                  </td>
                  <td className=" text-[10px] font-bold text-black uppercase">
                    {employments?.netGross || "N/A"}
                  </td>
                  <td className=" text-[10px] font-bold text-black uppercase">
                    {employments?.monthlyAnnual || "N/A"}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}